import * as yup from 'yup';
import useTranslation from '../../../Hooks/useTranslation';
import {
	conditionalStringOneOfValidation,
	phoneNumberOrEmailValidation,
} from '../Helpers/patientRegistration.helper';

export default function usePatientManualRegistrationLatamFormValidationScheme(
	isPeru: boolean,
	hasHealthPlans: boolean,
) {
	const { t } = useTranslation();

	const getValidationScheme = ({ isChild }: { isChild: boolean }) => {
		return yup
			.object({
				salutationBefore: yup.string().notRequired().nullable(),
				firstName: yup
					.string()
					.required(
						t('validation.patientManualRegistrationLatamForm.firstName'),
					),
				middleName: yup.string().notRequired().nullable(),
				fatherLastName: yup
					.string()
					.required(
						t('validation.patientManualRegistrationLatamForm.fatherLastName'),
					),
				motherLastName: !isPeru
					? yup.string().notRequired().nullable()
					: yup
							.string()
							.required(
								t(
									'validation.patientManualRegistrationLatamForm.motherLastName',
								),
							),
				lastName: yup.string().notRequired().nullable(),
				birthDate: yup
					.date()
					.typeError(
						t('validation.patientManualRegistrationLatamForm.birthDate') ?? '',
					)
					.required(
						t('validation.patientManualRegistrationLatamForm.birthDate'),
					),
				gender: yup
					.mixed()
					.required(t('validation.patientManualRegistrationLatamForm.gender')),
				email: yup
					.string()
					.email(t('validation.patientManualRegistrationLatamForm.email'))
					.nullable()
					.test(
						'email-required',
						t('validation.patientManualRegistrationLatamForm.email'),
						function (value) {
							return conditionalStringOneOfValidation(
								isChild,
								value,
								this.parent.phoneNumber,
							);
						},
					),
				phoneNumber: yup
					.string()
					.nullable()
					.test(
						'phone-required',
						t('validation.patientManualRegistrationCzechForm.phoneNumber'),
						function (value) {
							return conditionalStringOneOfValidation(
								isChild,
								value,
								this.parent.email,
							);
						},
					),
				identificationDocumentNumber: yup.string().notRequired().nullable(),
				healthPlanCode: !hasHealthPlans
					? yup.mixed().notRequired().nullable()
					: yup.object().shape({
							label: yup.string(),
							value: yup
								.string()
								.required(
									t(
										'validation.patientManualRegistrationLatamForm.healthPlanCode',
									),
								),
					  }),
				healthPlanWorkplaceMember: yup.mixed().notRequired().nullable(),
				legalRepresentative: isChild
					? yup.object().shape({
							firstName: yup
								.string()
								.required(
									t(
										'validation.patientManualRegistrationCzechForm.legalRepresentative.firstName',
									),
								),
							lastName: yup
								.string()
								.required(
									t(
										'validation.patientManualRegistrationCzechForm.legalRepresentative.lastName',
									),
								),
							email: yup
								.string()
								.email(t('validation.patientManualRegistrationCzechForm.email'))
								.required(
									t(
										'validation.patientManualRegistrationCzechForm.legalRepresentative.email',
									),
								),
							phoneNumber: yup.string().notRequired().nullable(),
					  })
					: yup.mixed().notRequired().nullable(),
			})
			.test(
				'phone-or-email',
				t('validation.patientManualRegistrationCzechForm.phoneOrEmailRequired'),
				value => phoneNumberOrEmailValidation(isChild, value),
			);
	};

	return { getValidationScheme };
}
